export default {
  familyName: 'Nunito Sans',
  fullName: 'Nunito Sans 12pt Regular',
  postscriptName: 'NunitoSans12pt-Regular',
  category: 'sans-serif',
  capHeight: 705,
  ascent: 1011,
  descent: -353,
  lineGap: 0,
  unitsPerEm: 1000,
  xHeight: 486,
  xWidthAvg: 452,
  subsets: {
    latin: {
      xWidthAvg: 452
    },
    thai: {
      xWidthAvg: 500
    }
  }
};
